import React, { Component } from 'react'
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {playButtonTap} from './PlaySounds';
import {setScore,setTime,isArrayRandamized,setCurrentIndex} from '../actions/commonActions';

class ResultScreen extends Component {
  

  goToMainMenu = () => {
        this.props.setScore(0);
        this.props.setTime(150);
        this.props.setCurrentIndex(0);
        this.props.isArrayRandamized(false);
        playButtonTap();
        this.props.history.push('/mainmenu');
    };

    shareOnFB  = () => {

    };
    
    render() {
      localStorage.setItem('language',this.props.language);
      var scoreStatement = "";
      var titleHeading = "";
      var titleText = "";
      var descriptionText = ""

      var direction = "";
      if(this.props.language === "en"){
        if(localStorage.getItem('game_mode') === "free"){
          scoreStatement = <div>Good job! You have reviewed<span className = "result_numbers"> {this.props.currentIndex+1} </span> <br/>
          Statments out of a <br/>
          total of <span className = "result_numbers"> {this.props.mythsAndFacts.length} </span>, and got <span className = "result_numbers"> {this.props.score} </span><br/>
          of them right! Play again if you want to review the explanations or challenge yourself with the timed challenge.</div>;
          
        }else{
            scoreStatement = <div><br/><br/>You Sorted<span className = "result_numbers"> {this.props.currentIndex+1} </span> <br/>
            Statments out of a <br/>
            total of <span className = "result_numbers"> {this.props.mythsAndFacts.length} </span><br/><br/> You got <span className = "result_numbers"> {this.props.score} </span><br/>
            of them right!<br/>
            Your Score is <span className = "result_numbers"> {this.props.score} </span></div>;
            
            }



      direction = "ltr";
      }else if(this.props.language === "ur"){

        if(localStorage.getItem('game_mode') === "free"){
          scoreStatement = <div>بہت خوب! آپ نے<span className = "result_numbers"> {this.props.mythsAndFacts.length} </span> <br/>
          میں سے <span className = "result_numbers"> {this.props.currentIndex+1} </span> <br/> بیانات کو ترتیب کیا اور ان میں سے <span className = "result_numbers"> {this.props.score} </span><br/>
          جوابات درست تھے </div>;

        }else{
          scoreStatement = <div>بہت خوب! آپ نے<span className = "result_numbers"> {this.props.mythsAndFacts.length} </span> <br/>
          میں سے <span className = "result_numbers"> {this.props.currentIndex+1} </span> <br/> بیانات کو ترتیب کیا اور ان میں سے <span className = "result_numbers"> {this.props.score} </span><br/>
          جوابات درست تھے </div>;
            
           // titleHeading = <div className = "result_title_heading">This score has earned you the<br/>title of</div>;

                // if(this.props.score >= 40){
                //     titleText = <div className = "result_title">COVID-19 specialist.</div>;
                // }else if(this.props.score >= 30 && this.props.score <= 39){
                //     titleText = <div className = "result_title">Informed Combatant.</div>;
                // }else if(this.props.score >= 20 && this.props.score <= 29){
                //     titleText = <div className = "result_title">Kinda Sorta Informed.</div>;
                // }else if(this.props.score >= 10 && this.props.score <= 19){
                //     titleText = <div className = "result_title">Believer of Myths.</div>;
                // }else if(this.props.score >= 0 && this.props.score <= 9){
                //     titleText = <div className = "result_title">CEO of Hoax News.</div>;
                // }

                }

    descriptionText = <div className = "result_desc">اپنا سکور بڑھانے اور کووڈ-١٩ کے بارے میں مزید سیکھنے کے لئے پھر سے کھیلیں <br/>یاد رکھیں، اپکا سکور دو چیزوں پر مبنی ہے؛ <br/>آپ نے کتنے بیانات کو ترتیب کیا اور اس میں کتنے جواب درست تھے </div>

          direction = "rtl";
      }
            return(
                <div className = "screen_background">
                  <div className = "popup result_popup">
                      <div dir={direction}>
                        {scoreStatement}
                        {titleHeading}
                        {titleText}
                        {descriptionText}
                      </div>  
                  </div>
                  <img src={"/game-skins/build-rev198-B6ETOYjbE/images_"+this.props.language+"/btn_play_again.png"} alt="" className="button home_button" onClick = {this.goToMainMenu}/><br/>
                  <a href="https://www.facebook.com/sharer/sharer.php?u=coronacombaturdu.gamingfordev.com/" target="_blank"><img src={"./images_"+this.props.language+"/btn_share.png"} alt="" className="button home_button d-none hidden" onClick = {this.shareOnFB}/></a>
                </div>
            )
    }
}

ResultScreen.propTypes = {
  language:PropTypes.string.isRequired
}
const mapStateToProps = state =>({
  language: localStorage.getItem('language'),
  currentIndex:state.config.currentIndex,
  mythsAndFacts:state.localData.mythsAndFacts,
  score:state.config.score
});
export default connect(mapStateToProps,{setScore,setTime,isArrayRandamized,setCurrentIndex})(ResultScreen);
//export default withRouter(IntroScreen);



// WEBPACK FOOTER //
// ./src/components/ResultScreen.js